/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg Fantasy Pts`)
};

const es_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts Fantasy Prom.`)
};

const de_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ø Fantasy-Pkt.`)
};

const nl_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem. fantasy-pnt.`)
};

const fr_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts fantasy moy.`)
};

const it_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts fantasy med.`)
};

const pt_br2_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts fantasy méd.`)
};

const pt_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts fantasy méd.`)
};

const ja_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均ファンタジーPt`)
};

const zh_f1_profile_stat_avg_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均梦幻分`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_stat_avg_fantasy = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_stat_avg_fantasy(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_stat_avg_fantasy", locale)
	if (locale === "en") return en_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "es") return es_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "de") return de_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "nl") return nl_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "fr") return fr_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "it") return it_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "pt") return pt_f1_profile_stat_avg_fantasy(inputs)
	if (locale === "ja") return ja_f1_profile_stat_avg_fantasy(inputs)
	return zh_f1_profile_stat_avg_fantasy(inputs)
};